
import { createReducer } from '@reduxjs/toolkit' ;
import { clearCreateAdminRequestResponse, createAccountOTTERIACMRequest, createAccountOTTERIACMRequestFailure, createAccountOTTERIACMRequestSuccess, createAdminRequest, createAdminRequestFailure, createAdminRequestSuccess, createCreateAccountOTTERIACMResponse } from '../actions/accountServiceAction';

const initialState = {
    createAccountResponse: null,
    createAdminAccountResponse: null,
    apiLoadingInProgress: false
};


const accountServiceReducer = createReducer(initialState, (builder) => {
	builder
    .addCase(createAccountOTTERIACMRequest, (state, action) => {
        state.apiLoadingInProgress = true
    }).addCase(createAccountOTTERIACMRequestSuccess, (state, action) => {
        state.createAccountResponse = action.payload.data
        state.apiLoadingInProgress = false
    }).addCase(createAccountOTTERIACMRequestFailure, (state, action) => {
        state.createAccountResponse = { msg: 'ERROR', details: action.payload.data };
        state.apiLoadingInProgress = false
    }).addCase(createCreateAccountOTTERIACMResponse, (state, action) => {
        state.createAccountResponse = null;
    })

    .addCase(createAdminRequest, (state, action) => {
        state.apiLoadingInProgress = true
    }).addCase(createAdminRequestSuccess, (state, action) => {
        state.createAdminAccountResponse = action.payload.data
        state.apiLoadingInProgress = false
    }).addCase(createAdminRequestFailure, (state, action) => {
        state.createAdminAccountResponse = { msg: 'ERROR', details: action.payload.data };
        state.apiLoadingInProgress = false
    }).addCase(clearCreateAdminRequestResponse, (state, action) => {
        state.createAdminAccountResponse = null;
    })
	builder.addDefaultCase((state) => state); 
});

export default accountServiceReducer;
